import { Accordion, BasicCollapsible, BoundedContent, Box, H2 } from '@vp/swan';
import { __ } from '@99designs/i18n';

export function IntelligentBriefFAQ() {
    return (
        <BoundedContent style={{ width: '100%' }} pt={7} pb={7} px={0}>
            <Box>
                <H2 fontSize="x2large">
                    {__('Frequently Asked Questions', {
                        _context: 'This is the title for a FAQ section',
                    })}
                </H2>
                <Accordion>
                    <BasicCollapsible
                        collapsibleId="is-this-ai"
                        heading={__("Is this AI? I thought I'd be working with a designer?", {
                            _context: `FAQ section: heading for the question "Is this AI? I thought I'd be working with a designer?"`,
                        })}
                    >
                        {__(
                            "You'll absolutely be working with a real human designer! This brief system simply uses AI assistance to help gather information about your project. Once your brief is complete, it will be assigned to one of our professional designers who will use your input to create a design. Think of the AI as a smart intake form that makes sure your human designer has everything they need to deliver exactly what you're looking for.",
                            {
                                _context: `FAQ section: answer to the question "Is this AI? I thought I'd be working with a designer?"`,
                            }
                        )}
                    </BasicCollapsible>
                    <BasicCollapsible
                        collapsibleId="what-to-include"
                        heading={__(
                            'What information should I include in my brief to get the best results?',
                            {
                                _context:
                                    'FAQ section: heading for the question "What information should I include in my brief to get the best results?"',
                            }
                        )}
                    >
                        {__(
                            "The more details you can give, the better for our professional designers. Clear direction about your design vision and preferences helps our designers create exactly what you need. During the tailored brief process, you'll have the chance to share details about your style, business and project. It's best if you have examples that inspire you, colors that work with your brand, and any must-have elements for your design. But even if your vision isn't fully formed, that's perfectly fine. Our designers are skilled at filling in the gaps.",
                            {
                                _context:
                                    'FAQ section: answer to the question "What information should I include in my brief to get the best results?"',
                            }
                        )}
                    </BasicCollapsible>
                    <BasicCollapsible
                        collapsibleId="who-will-be-working-on-my-design-project"
                        heading={__('Who will be working on my design project?', {
                            _context:
                                'FAQ section: heading for the question "Who will be working on my design project?"',
                        })}
                    >
                        {__(
                            "Your design will be created by one of our skilled professional designers who work from Vistaprint's studios located around the world. We'll assign a designer to your project based on your creative requirements. While you won't choose your designer directly, we ensure each project is matched with someone with the right experience. Every designer on our team is trained to create designs that work perfectly with our products, so the final design will look great on your selected physical product.",
                            {
                                _context:
                                    'FAQ section: answer to the question "Who will be working on my design project?"',
                            }
                        )}
                    </BasicCollapsible>
                    <BasicCollapsible
                        collapsibleId="can-i-speak-directly-with-my-designer"
                        heading={__('Can I speak directly with my designer?', {
                            _context:
                                'FAQ section: heading for the question "Can I speak directly with my designer?"',
                        })}
                    >
                        {__(
                            `Yes, absolutely! While completing your brief, you have the option to select "DesignLive", which allows you to book a video call with your designer. In this session, your designer will come prepared with an initial concept based on your design brief. You'll then have the opportunity to discuss your project and collaborate to refine the design in real time.
If you don't select DesignLive, our standard process uses email and our online platform to provide feedback.`,
                            {
                                _context:
                                    'FAQ section: answer to the question "Can I speak directly with my designer?"',
                            }
                        )}
                    </BasicCollapsible>
                </Accordion>
            </Box>
        </BoundedContent>
    );
}
